module.exports = __webpack_public_path__ + "static/Order-Shipping-Planning-e261ec469d2df324d82c6ec9d9eee5a8.jpg";